<template>
  <div class="service_order">
    <!-- 非创新券订单 -->
    <el-form ref="form" inline :model="form" label-width="80px">
      <el-form-item label="订单号">
        <el-input v-model="form.code" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="订单状态">
        <el-select v-model="form.status" style="width:200px;" v-if="statusList.length">
          <el-option label="全部" value></el-option>
          <el-option
            v-for="(item,index) in statusList"
            :key="item.id"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务类型">
        <el-select v-model="form.type" style="width:200px;" v-if="statusList.length">
          <el-option label="全部" value></el-option>
          <el-option
            v-for="(item,index) in typeList"
            :key="item.id"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" @click="getOrders">搜索</el-button>
    </el-form>
    <!-- element表格 -->
    <div class="order_dynamic_content">
      <div class="table">
        <myTable :tableObj="tableObj" @btnClick="btnclick" @changePageNo="changePageNo"></myTable>
      </div>
    </div>

    <!-- 评价弹窗 -->
    <setEevallate
      :details="orderDetail"
      :viewReviews="viewReviews"
      :dialogVisible="centerDialogVisible"
      @close="close"
    ></setEevallate>
    <!-- 查看意见 -->
    <el-dialog title="查看意见" :visible.sync="dialogVisible3" width="600px" center>
      <span v-if="row && row.examine_remark" v-cloak>{{row.examine_remark}}</span>
      <span v-else-if="row && row.sale_user_remark" v-cloak>{{row.sale_user_remark}}</span>
      <span v-else>暂无</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible3 = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import myTable from "@/components/my_table.vue";
import setEevallate from "../components/setEevallate.vue"; //评价弹窗
export default {
  components: {
    myTable,
    setEevallate
  },
  data() {
    return {
      form: {},
      statusList: [
        {
          code: "ServiceOrderStatusPay",
          name: "已支付"
        },
        {
          code: "ServiceOrderStatusComplete",
          name: "已完成"
        }
      ],
      typeList: [],
      tableObj: {
        tableName: "zl",
        list: [], //列表数据
        btns: [
          //按钮组
          {
            name: "查看详情",
            funcName: "showDetail"
          },
          {
            //买家
            name: "催单",
            funcName: "reminder",
            formatter: function(row) {
              return row.status === "ServiceOrderStatusWait"; //待接单
            }
          },
          {
            //买家
            name: "查看意见",
            funcName: "seeSuggestion",
            formatter: function(row) {
              return row.status === "ServiceOrderStatusIAOut"; //申领不通过
            }
          },
          {
            //买家
            name: "确认支付",
            funcName: "pay",
            formatter: function(row) {
              return row.status === "ServiceOrderStatusAccept"; //已接单
            }
          },
          {
            //买家
            name: "服务完成",
            funcName: "serviceSompletion",
            formatter: function(row) {
              return row.status === "ServiceOrderStatusCollection"; //已收款
            }
          },
          {
            name: "评价",
            funcName: "evaluate",
            formatter: function(row) {
              return (
                !row.is_evaluate && row.status === "ServiceOrderStatusComplete" //已完成
              );
            }
          }
        ],
        table_detail: [
          //table详情
          {
            prop: "",
            width: "250px",
            label: "商品信息",
            formatter: function(row) {
              return `<div class="first"><p>订单号: ${row.code}</p><p>订购时间：${row.create_date}</p><a href="#/supermarket/shop_detail?id=${row.service}" class=""><div class="img-name"><img src="${row.coverPath}" alt=""><p><span>${row.name}</span><span>${row.service_scales_Name}</span></p></div></a></div>`;
            }
          },
          {
            prop: "type_name",
            label: "服务类型"
          },
          {
            prop: "price",
            label: "单价"
          },
          {
            prop: "nums",
            label: "数量"
          },
          {
            prop: "is_coupon",
            label: "使用创新券",
            formatter: function(row) {
              return row.is_coupon ? "是" : "否";
            }
          },
          {
            prop: "",
            label: "金额",
            formatter: function(row) {
              let _text = row.is_complete ? "实际支付" : "预计支付";
              return `<div class="money"><div class="color_gary">原价￥${row.total_money}</div><div>${_text}</div><div style="border-bottom:1px solid #f0f0f0;">￥${row.expected_money}</div></div>`;
            }
          },
          {
            prop: "status_name",
            label: "订单状态",
            formatter: function(row) {
              return row.is_complete ? "已完成" : row.status_name;
            }
          }
        ],
        layerpageinfo: {
          //分页
          pageNo: 0,
          total: 10,
          pageSize: 10
        }
      },
      tableData: [],
      centerDialogVisible: false, //评价弹窗
      viewReviews: false, //true 查看评价详情 false进行评价
      orderDetail: {}, //订单详情弹窗内容
      row: {}, //单行列表数据
      certificationType: "CertificationTypeInnovate", //传入买家身份
      dialogVisible3: false //查看意见
    };
  },
  created() {
    this.getOrders();
    this.getType();
  },
  methods: {
    /* 服务类型子类型*/

    async getType() {
      let list = [];
      let res = await this.getDictionaries("RangeServicesResearch");
      list = [...list, ...res.obj.list];
      let res2 = await this.getDictionaries("RangeServicesCheck");
      list = [...list, ...res2.obj.list];
      let res3 = await this.getDictionaries("RangeServicesShare");
      list = [...list, ...res3.obj.list];
      let res4 = await this.getDictionaries("RangeServicesOther");
      list = [...list, ...res4.obj.list];
      this.typeList = list;
    },
    /** 获取字典数据 */
    getDictionaries(typeCode, obj) {
      return new Promise((resolve, reject) => {
        let params = {
          typeCode: typeCode,
          pageNo: 0,
          pageSize: 999,
          ...obj
        };
        this.api.getDictionaries(params).then(res => {
          if (res.error["err_code"] !== 0) return;
          resolve(res);
        });
      });
    },
    /* 订单查询 */
    getOrders() {
      let params = {
        active: true,
        user_id: sessionStorage.getItem("user_id"),
        certificationType: "CertificationTypeInnovate", //传入买家身份
        is_coupon: false,
        ...this.tableObj.layerpageinfo,
        ...this.form
      };
      this.api.getServiceOrders(params, true).then(res => {
        if (res.error.err_code !== 0) return;
        this.tableObj.list = res.obj.list;
        this.tableObj.layerpageinfo.total = res.obj.totalSize;
      });
    },
    /** table中的按钮点击*/
    btnclick(obj) {
      switch (obj.btnFuncName) {
        case "showDetail":
          let routeUrl = this.$router.resolve({
            name: "order_details",
            query: { code: obj.row.code, identity: "buyer", type: 2 }
          });
          console.log(routeUrl)
          window.open(routeUrl.href, "_blank");
          break;
        case "reminder": //催单
          this.reminder(obj.row);
          break;
        case "seeSuggestion": //查看意见
          this.dialogVisible3 = true;
          this.row = obj.row;
          break;
        case "evaluate": //去评价
          this.gradeDialog(obj.row);
          break;
        case "pay": //支付
          this.publick_server_sure(obj.row, {
            title: "是否确认支付？",
            operation: "ServiceOrderStatusPay",
            succ_text: "支付成功！"
          });

          break;
        case "serviceSompletion": //服务完成
          this.publick_server_sure(obj.row, {
            title: "确认服务完成？",
            operation: "ServiceOrderStatusComplete",
            succ_text: "服务完成！"
          });
          break;
        case "reasons": //拒绝理由
          this.dialogVisible3 = true;
          this.row = obj.row;
          break;
      }
    },
    /** 催单*/

    reminder(row) {
      this.api.reminder({ id: row.id }, true).then(res => {
        if (res.error.err_code !== 0) return;
        this.$message({
          type: "success",
          message: `催单成功!`
        });
      });
    },
    /**流程公共确认弹窗 */
    publick_server_sure(row, tmp) {
      this.$confirm(tmp.title, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(({ value }) => {
        let params = {
          operation: tmp.operation,
          id: row.id,
          user_sale_id: row.user_sale_id
        };
        this.api.operationServiceOrderNotCoupon(params, true).then(res => {
          if (res.error.err_code !== 0) return;
          this.$message({
            type: "success",
            message: `${tmp.succ_text}!`
          });
          this.getOrders();
        });
      });
    },
    /** 页码改变
     * @params obj.val 当前页码
     * @params obj.tableName 表格名称*/
    changePageNo(obj) {
      this.tableObj.layerpageinfo.pageNo = obj.val;
      this.getOrders();
    },
    /* 订单评价弹窗 初始化评价弹窗 */
    gradeDialog(row) {
      this.orderDetail = Object.assign({}, row, {
        anonymous: false,
        content: "",
        grade: 0, //商品评分星星等级
        score_major: 0, //专业评分星星等级
        score_service: 0, //服务评分星星等级
        score_speed: 0 //速度评分星星等级
      });
      this.centerDialogVisible = true;
    },
    close(obj) {
      if (obj.name === "evalate") {
        //评价弹窗关闭
        this.centerDialogVisible = obj.dialogVisible;
        this.getOrders();
      }
    }
  }
};
</script>

<style lang="scss">
.service_order {
  .first {
    text-align: left;
    a {
      color: #333;
    }
    .img-name {
      display: flex;
      img {
        display: block;
        width: 80px;
        height: 80px;
      }
      p {
        flex: 1;
        padding-left: 10px;
        text-align: left;
        line-height: 18px;
        span {
          display: block;
        }
      }
    }
  }
  .money {
    text-align: center;
    font-weight: 500;
    color: #000;
  }
  .color_gary {
    color: #999;
  }
}
</style>